import gql from 'graphql-tag'

export const areaSimpleFragment = gql`
  fragment AreaFragmentSimple on Area {
    id
    name
  }
`

export const areaFragment = gql`
  fragment AreaFragment on Area {
    ...AreaFragmentSimple
    participantsCount
    coursesCount
    hoursTotal
    coursesProgress {
      finish
      inProgress
      pending
    }
  }
  ${areaSimpleFragment}
`
